module.exports = __webpack_public_path__ + "static/img/index_ai_resume.3abe6f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/index_ai_resume.png
// module id = 61en
// module chunks = 1